
class SupportV1StepActionsModel
  toHash: ->
    hash1 =
      orderId: if Groupon.Support.currentOrder?.id? then Groupon.Support.currentOrder.id.toString() else "noorder"
      tagline: if Groupon.Support.Tagline? then Groupon.Support.Tagline else ""
      notOrderRelatedText: I18n.t("js.modules.support.quesorder")
      isRefundEligible: window.evaluate(Groupon.Support.ContentModel.isRefundEligible)

    unless window.isUS()
      hash1.intl = "intl-not-order-related"

    if window.faqInsteadHelpWizard is true
      hash2 =
        contToStepTwoBtnText: I18n.t("js.modules.support.cont_to_step2")
        contToStepThreeBtnText: I18n.t("js.modules.support.cont_to_contact_us")
        needHelpBtnText :I18n.t("js.modules.support.no_contact_us")
    else
      hash2 =
        contToStepTwoBtnText : I18n.t("js.modules.support.contorder")
        needHelpBtnText: I18n.t("js.modules.support.needhelp")
        refundMyRequest: I18n.t("js.modules.support.req_my_refund")
        contToStepThreeBtnText: I18n.t("js.modules.support.cont")
    hash = (_.extend hash1, hash2)
    if Groupon.Support.MAXINDEX is 3
      if Groupon.Support.CURRENTVIEW.id is 1
        _.extend hash, window.getOrderInfoForBH(Groupon.Support.currentOrder)
      else if Groupon.Support.CURRENTVIEW.id is 2
        hash.showChat =  Groupon.Support.LiveChatModel.shouldShowStepTwoLiveChat()
    else if Groupon.Support.MAXINDEX is 2
      if Groupon.Support.CURRENTVIEW.id is 1
        hash.showChat =  Groupon.Support.LiveChatModel.shouldShowStepTwoLiveChat()
    hash

module.exports = SupportV1StepActionsModel
